import { useEffect, useState } from "react";
import { postSearchInitialOrderSummaryApi, postSearchOrderSummaryApi } from "../../../../http/api/OrderSummaryAPI";
import { stripTrailingZeros } from "../../../../utils/decimal";

const ROW_COUNT_PER_PAGE = 20;

const useOrderSummary = () => {

  const [orders, setOrders] = useState([]);

  const [shippingDate, setShippingDate] = useState(null);
  const [page, setPage] = useState(1);
  
  const [tabPos, setTabPos] = useState(1);

  useEffect(() => {
    (async () => {
      searchInitial()
    })();
  }, []);

  const search = async (shippingDate) => {
    const orderSummaryRes = await postSearchOrderSummaryApi({shippingDate});
    setOrders(orderSummaryRes.orderSummaries);
    setPage(1);
  }

  const searchInitial = async () => {
    const orderSummaryRes = await postSearchInitialOrderSummaryApi({});

    setShippingDate(orderSummaryRes.shippingDate);
    setOrders(
      orderSummaryRes.orderSummaries.map((orderSummary) => ({
        ...orderSummary,
        totals : orderSummary.totals.map((total) => ({
          ...total,
          orderQuantityTotal: total.orderQuantityTotal ? stripTrailingZeros(total.orderQuantityTotal) : "",
        })),
        details: orderSummary.details.map((detail) => ({
          ...detail,
          orderQuantity: detail.orderQuantity ? stripTrailingZeros(detail.orderQuantity): "",
        })),
      }))

    );
  }

  const changeShippingDate = async (shippingDate) => {
    setShippingDate(shippingDate);
    await search(shippingDate);
  }

  const movePage = (page) => {
    setPage(page);
  }

  const changeTabPosition = (tabPos) => {
    setTabPos(tabPos);
  }

  const filteredOrders = orders.filter((order) => order.product.orderTypeId === tabPos);

  return {
    orders: filteredOrders.slice(
      ROW_COUNT_PER_PAGE * (page - 1),
      ROW_COUNT_PER_PAGE * page
    ),
    shippingDate,
    changeShippingDate,
    page,
    maxPage : Math.max(1, Math.ceil(filteredOrders.length / ROW_COUNT_PER_PAGE)),
    movePage,
    tabPos,
    changeTabPosition
  }
};

export default useOrderSummary;